import React, { useState } from "react";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  Typography,
  Snackbar,
  Alert,
  CircularProgress,
  Box,
  Fab,
} from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import moment from "moment";
import { Link, useHistory } from "react-router-dom";
import { CustomizedMenus, StyledTableRow } from "../../helpers/CustomMenu";
import SmallModal from "../Modal/SmallModel";
import FullScreenModal from "../Modal/FullScreenModal";
import ViewParticipants from "./CreateMinutes/ViewParticipants";
import Modal from "../Modal/Modal";
import { AddMenu } from "./Participants/Menu";
import CreateModal from "./CreateMeeting/AddParticipant";
import { CustomizedMenusUser, ReviewUser } from "../../helpers/Approver";
import { participantsInitialState } from "./CreateMeeting/Participants";
import { IUser } from "../../store/User/type";
import { getTime } from "../../helpers/GetTime";
import JoditEditorExample from "../../helpers/JoditEditorExample";
import { downloadUrl } from "../../helpers/DownloadDocument";
import SelectApprover from "../../helpers/SelectApprover";
import UserRole from "../../helpers/UserRole";
import SelectEmployee from "../../helpers/SelectEmployee";
import { getJsonValue } from "../../helpers/Common_functions";
import { SubmitButton } from "../buttons";
import { meetingBaseUrl } from "../../store/helpers/axios";
import { errorToast, successToast } from "../../helpers/Notification";
import { green } from "@mui/material/colors";
import CheckIcon from "@mui/icons-material/Check";
import HighlightOffRoundedIcon from "@mui/icons-material/HighlightOffRounded";
import { AiFillEdit, AiFillDelete } from 'react-icons/ai';
import { meetingType } from "./CreateMeeting/Create";

const MeetingDetails = (props) => {
  const {
    meeting,
    MeetingDetails,
    setStatus,
    ranks,
    systemSettings,
    setCategory,
    onSubmit,
    removeUser,
    onSelectUser,
    GetUsersByStructure,
    selectedEmployees,
    setSelectedEmployees,
    users,
    structure,
    setSearchStructure,
    searchStructure,
    loggedUser,
    selectedUsers,
    GetAllChildren,
    GetSameLevelStructure,
    GetAllStructure,
    setOwners,
    owners,
    GetEmployees,
    settings,
    setContent,
    content,
    errorMessage,
    setSnack,
    SearchStructure,
    snack,
    setDocument,
    selectedRoles,
    category,
    removeRole,
    onSelectRole,
    resources
  } = props;
  const mainBackground = systemSettings?.mainBackground;

  const [select, setSelect] = useState(false);
  const [select2, setSelect2] = useState(false);
  const [viewComment, setViewComment] = useState(false);
  const [message, setMessage] = useState("");
  const [comment, setComment] = useState("");
  const [addComment, setAddComment] = useState("");
  const [commentStatus, setCommentStatus] = useState("");
  const [viewParticipants, setViewParticipants] =
    React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectUser, setSelectUser] = useState(false);
  const [other, setOther] = useState(false);
  const [editObject, setEditObject] = useState([]);
  const [view, setView] = useState(false);
  const [user, setUser] = useState();
  const [initialParticipants, setInitialParticipants] = React.useState(
    participantsInitialState
  );
  const [index, setIndex] = useState();
  const [loading, setLoading] = useState(false);
  const [apply, setApply] = useState(false);
  const [selectEmployee, setSelectEmployee] = useState(false);
  const canAccess =
    loggedUser?.id === meeting?.creator
  // const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  let participants = [];
  participants = meeting?.MeetingParticipants;
  let history = useHistory();

  const part =
    participants?.filter((part) => part?.email === loggedUser?.email) ??
    [];

  const buttonSx = {
    bgcolor: green[500],
    "&:hover": {
      bgcolor: green[700],
    },
  };

  // let isCreator = meeting?.createdBy?.id === loggedUser.userId;
  const EditValue = (value) => {
    let array = [...owners];
    let index = array.indexOf(editObject);
    owners[index] = value;
    setEditObject([]);
  };
  const userProps = {
    SearchStructure,
    setSelect: setSelectUser,
    select: selectUser,
    users,
    type: "",
    onSelectUser,
    selectedUsers,
    removeUser,
    structure,
    GetUsersByStructure,
    GetAllChildren,
    GetSameLevelStructure,
    GetAllStructure,
    setSearchStructure,
    loggedUser,
    searchStructure,
    title: "Select Participants",
    onSelectRole,
    selectedRoles,
  };
  let supportDocuments = meeting.attachment
    ? meeting.attachment.split(",")
    : [];

  const confirmAvailability = (e) => {
    e.preventDefault();
    const URL = `/api/meeting/confirm-availability/?meetingId=${meeting?.id}&status=${commentStatus}&email=${loggedUser?.email}`;
    meetingBaseUrl
      .post(URL, { comment: addComment, inSystem: true })
      .then((response) => {
        if (response.status === 200) {
          setLoading(false);
          setViewComment(false);
          successToast("confirmed");
          MeetingDetails(meeting?.id);
        }
      })
      .catch((error) => {
        // if (error?.response?.status === 400) {
        setLoading(false);
        errorToast(error?.response?.data?.message);
        // }
      });

    setLoading(true);
  };
  const minutes = meeting?.Minutes && meeting?.Minutes[0];
  return (
    <div>
      <CreateModal
        initialState={initialParticipants}
        editObject={editObject}
        // owners={owners}
        ranks={ranks}
        setEditObject={setEditObject}
        EditValue={EditValue}
        getValue={(value) => {
          setOwners((arr) => [...arr, value]);
        }}
        toggleModal={setOther}
        open={other}
        setSelectedEmployees={setSelectedEmployees}
        selectedEmployees={selectedEmployees}
      />
      <ReviewUser user={user} view={view} setView={setView} />
      {category === "role" ? (
        <FullScreenModal setSelect={setSelect} select={select}>
          <UserRole {...userProps} setSelect={setSelect} />
        </FullScreenModal>
      ) : (
        <FullScreenModal setSelect={setSelect} select={select}>
          <SelectApprover
            {...userProps}
            getNewAllStructure={true}
            checkAll={true}
            setSelect={setSelect}
          />
        </FullScreenModal>
      )}
      <SmallModal select={apply} setSelect={setApply} confirm={onSubmit}>
        <i className="fa fa-check-circle fa-4x  text-success me-2" />
        <span>{message}</span>
      </SmallModal>
      <Modal
        select={select2}
        setSelect={setSelect2}
        title={"Inform Participants"}>
        <Card>
          <CardContent>
            <JoditEditorExample
              htmlContent={content}
              onBlur={(str) => {
                setContent(str.target.value);
              }}
            />
            <label className="mt-4">Attachment</label>
            <input
              type={"file"}
              className="form-control form-control-sm "
              onChange={(e) => setDocument(e.target.files)}
              multiple
            />
          </CardContent>
          <CardActions className={"float-end"}>
            <Button onClick={() => setSelect2(false)}>Cancel</Button>
            <Button
              color="success"
              onClick={() => {
                setSelect2(false);
                onSubmit();
              }}
            >
              Confirm
            </Button>
          </CardActions>
        </Card>
      </Modal>
      <Card>
        <CardHeader
          title={
            <span className="text-capitalize">
              Status :
              {meeting?.status === "completed" ? (
                <em className="badge bg-green-700 rounded-full py-1 px-2 text-white">
                  {meeting?.status}
                </em>
              ) : meeting?.status === "canceled" ? (
                <em className="badge bg-danger bg-red-700 rounded-full py-1 px-2 text-white">
                  {meeting?.status}
                </em>
              ) : (
                <em className="badge bg-cyan-700 rounded-full py-1 px-2 text-white">
                  {meeting?.status}
                </em>
              )}
            </span>
          }
          subheader={
            <span>
              Created At : {moment(meeting?.createdAt).format("DD/MM/yyyy")}
            </span>
          }
          titleTypographyProps={{ variant: "h6" }}
          action={
            part[0] ? (
              <Box sx={{ m: 1, position: "relative" }}>
                <Button
                  variant="contained"
                  disabled={meeting?.status === "scheduled" ? loading : true}
                  color={
                    part[0]?.status === "denied"
                      ? "error"
                      : part[0]?.status === "confirmed"
                        ? "success"
                        : "warning"
                  }
                  onClick={() => setViewComment(true)}
                >
                  {part[0]?.status === "denied" ? (
                    <HighlightOffRoundedIcon />
                  ) : part[0]?.status === "confirmed" ? (
                    <CheckIcon color="green" />
                  ) : (
                    <WarningAmberIcon />
                  )}

                  {part[0]?.status
                    ? part[0]?.status
                    : "confirm your availability"}
                </Button>
              </Box>
            ) : null
          }
        />
        <CardContent>
          <Card className="mb-3">
            <CardHeader
              title={
                <Typography className="text-capitalize" variant={"h5"}>
                  Meeting Details
                </Typography>
              }
              titleTypographyProps={{ variant: "h6" }}
            />
            <CardContent>
              <div className={"row mt-3 grid grid-cols-3 gap-4"}>
                <div className={"col-md-4"}>
                  <h3 className="text-capitalize fw-bold mb-2 font-bold">
                    Start
                  </h3>
                  <div>
                    {/* <Typography variant={"body2"}>
                      {getTime(meeting?.start)}
                    </Typography> */}

                    <Typography variant={"body2"}>
                      {moment(meeting?.start).utc().format("YYYY-MM-DD HH:mm")}
                    </Typography>
                  </div>
                </div>
                <div className={"col-md-4"}>
                  <h3 className="text-capitalize fw-bold font-bold">
                    End
                  </h3>
                  <div>
                    {/* <Typography variant={"body2"}>
                      {getTime(meeting?.end)}
                    </Typography> */}
                    <Typography variant={"body2"}>
                      {moment(meeting?.end).utc().format("YYYY-MM-DD HH:mm")}
                    </Typography>
                  </div>
                </div>
                <div className={"col-md-4"}>
                  <h3 className="text-capitalize fw-bold font-bold">
                    Duration
                  </h3>
                  <div>
                    <Typography variant={"body2"}>
                      {meeting?.duration}
                    </Typography>
                  </div>
                </div>
                {/* </div>
              <div className={"row mt-3 "}> */}
                <div className={"col-md-4"}>
                  <h3 className="text-capitalize fw-bold font-bold mb-2">
                    Name
                  </h3>
                  <div>
                    <Typography variant={"body2"}>{meeting?.name}</Typography>
                  </div>
                </div>
                <div className={"col-md-4"}>
                  <h3 className="text-capitalize fw-bold font-bold mb-2">
                    Room/Venue
                  </h3>
                  <div>
                    {meeting?.Room === null || meeting?.roomId === null ? (
                      <Typography variant={"body2"}>
                        {meeting?.status !== "completed" || meeting?.status === "canceled" ? (
                          <a href={meeting?.venue} target="_blank" rel="noopener noreferrer">
                            <span className="text-primary">
                              <i className="fa fa-video-camera me-1" />
                              Join Meeting
                            </span>
                          </a>
                        ) : (
                          <span className="text-secondary">
                            Virtual
                          </span>
                        )}
                      </Typography>
                    ) : (
                      <Typography variant={"body2"}>
                        {meeting?.Room?.name ?? meeting?.venue}
                      </Typography>
                    )}
                  </div>
                </div>
                <div className={"col-md-4"}>
                  <h3 className="text-capitalize fw-bold font-bold mb-2">
                    Reminder
                  </h3>
                  <div>
                    <Typography variant={"body2"}>
                      {meeting?.reminder}
                    </Typography>
                  </div>
                </div>
                {/* </div>
              <div className={"row mt-3"}> */}
                <div className={"col-md-4 "}>
                  <h3 className="text-capitalize fw-bold font-bold mb-2">
                    type
                  </h3>
                  <div>
                    <Typography>{meeting?.type}</Typography>
                  </div>
                </div>
                {/* <div className={"col-md-4 "}>
                  <h3 className="text-capitalize fw-bold font-bold mb-2">
                    Project
                  </h3>
                  <div>
                    <Typography>{meeting?.allProject ? 'All' : meeting?.Project?.name}</Typography>
                  </div>
                </div> */}
                {meeting?.projectId ?
                  <div className={"col-md-4 "}>
                    <h3 className="text-capitalize fw-bold font-bold mb-2">
                      Client
                    </h3>
                    <div>
                      <Typography>{meeting?.Project?.client}</Typography>
                    </div>
                  </div>
                  : null}
              </div>
              {supportDocuments.length ? (
                <div className="row form-group mt-3">
                  <div className={"col-md-12 "}>
                    <h3 className="form-label fw-bold font-bold">
                      Document
                    </h3>
                  </div>
                  <div className="col-md-12 mt-1">
                    {supportDocuments.map((doc) => (
                      <Button
                        onClick={() => {
                          window.open(`${downloadUrl}/${doc}`);
                        }}
                      >
                        {doc}
                      </Button>
                    ))}
                  </div>
                </div>
              ) : null}
            </CardContent>
          </Card>
          <Card className="mb-3">
            <CardHeader
              title={
                <h5 variant={"h5"} className="text-capitalize">
                  Agenda
                </h5>
              }
              titleTypographyProps={{ variant: "h6" }}
            />
            <CardContent>
              <div className={"row mb-3"}>
                {meeting?.agenda ? (
                  <div className={"row"}>
                    <div className={"col-md-12"}>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: meeting?.agenda,
                        }}
                      ></div>
                    </div>
                  </div>
                ) : null}
              </div>
            </CardContent>
          </Card>
          <Card className="mb-3">
            <CardHeader
              title={
                <h5 variant={"h5"} className="text-capitalize">
                  Meeting Initiator
                </h5>
              }
              titleTypographyProps={{ variant: "h6" }}
            />
            <CardContent>
              <div className={"row mb-3"}>
                <TableContainer>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Names</TableCell>
                        <TableCell>Email</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <StyledTableRow>
                        <TableCell>
                          {meeting?.createdBy?.Resource?.names} - <span className="italic"> {meeting?.createdBy?.Resource?.category} </span>
                        </TableCell>
                        <TableCell>{meeting?.createdBy?.email}</TableCell>
                      </StyledTableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            </CardContent>
          </Card>
          <Card>
            <CardHeader
              title={
                <Typography variant={"h5"} className="text-capitalize">
                  <span className="text-center me-2">Participants:</span>
                  <span className={"text-center text-secondary me-2 fs-4"}>
                    {participants?.length}
                  </span>
                </Typography>
              }
              titleTypographyProps={{ variant: "h6" }}
              action={
                <div>
                  <Button
                    style={{ color: mainBackground }}
                    onClick={() => {
                      setViewParticipants(true);
                    }}>

                    <i className="fa fa-users fa-md me-1 " /> View Participants
                  </Button>
                  {meeting?.status === "scheduled" && canAccess && (
                    <Button onClick={handleClick}
                      style={{ color: mainBackground}}
                    >
                      <i className="fa fa-plus fa-md me-1 " /> Add New
                    </Button>
                  )}
                  <AddMenu
                    anchorEl={anchorEl}
                    handleClose={handleClose}
                    setSelect={setSelectUser}
                    setOther={setOther}
                    setSelectEmployee={setSelectEmployee}
                    setCategory={(e) => {
                      setCategory(e);
                      setSelect(true);
                    }}
                  />
                </div>
              }
            />
            {category === "role" ? (
              <CardContent>
                <div>
                  <TableContainer>
                    <Table size={"small"}>
                      <TableHead>
                        <TableRow>
                          <TableCell>#</TableCell>
                          <TableCell>Role Name</TableCell>
                          <TableCell>Action</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {selectedRoles.map((role, index) => (
                          <StyledTableRow>
                            <TableCell>#{index + 1}</TableCell>
                            <TableCell>{role?.name}</TableCell>
                            <TableCell>
                              <CustomizedMenusUser
                                // setView={setView}
                                setUser={() => {
                                  // setUser(user);
                                }}
                                onDelete={() => {
                                  removeRole(role);
                                }}
                              />
                            </TableCell>
                          </StyledTableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              </CardContent>
            ) : owners.length ||
              selectedUsers.length ||
              selectedEmployees.length ? (
              <div>
                <TableContainer>
                  <Table size={"small"}>
                    <TableHead>
                      <TableRow>
                        <TableCell>#</TableCell>
                        {initialParticipants?.map((v) => (
                          <TableCell className="text-capitalize">
                            {v.label}
                          </TableCell>
                        ))}
                        <TableCell>Action</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {owners.map((owner, index) => (
                        <StyledTableRow>
                          <TableCell>#{index + 1}</TableCell>
                          {owner.map((v) => (
                            <TableCell>{v.value}</TableCell>
                          ))}
                          <TableCell>
                            <CustomizedMenus
                              owner={owners[index]}
                              setIndex={setIndex}
                              index={index}
                              setEditObject={setEditObject}
                              onDelete={() => {
                                setOwners([
                                  ...owners.slice(0, index),
                                  ...owners.slice(index + 1),
                                ]);
                              }}
                              setModelOpen={setOther}
                            />
                          </TableCell>
                        </StyledTableRow>
                      ))}
                      {selectedEmployees?.map(
                        (user, index) => (
                          <StyledTableRow key={index}>
                            <TableCell>#{index + 1}</TableCell>
                            <TableCell>{user?.names}</TableCell>
                            <TableCell>{user?.category}</TableCell>
                            <TableCell>{user?.phone}</TableCell>
                            <TableCell>{user?.email}</TableCell>
                            <TableCell >
                              <div className="grid grid-cols-2 gap-2">
                                <AiFillEdit
                                  onClick={() => {
                                    const newEmp = selectedEmployees.filter((emp) => (emp.email != selectedEmployees[index].email));
                                    setSelectedEmployees(newEmp);
                                  }}
                                  color="blue"
                                  size={22}
                                  className="cursor-pointer" />
                                <AiFillDelete
                                  onClick={() => {
                                    const newEmp = selectedEmployees.filter((emp) => (emp.email != selectedEmployees[index].email));
                                    setSelectedEmployees(newEmp);
                                  }}
                                  color="red"
                                  size={22}
                                  className="cursor-pointer" />
                              </div>
                            </TableCell>
                          </StyledTableRow>
                        )
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            ) : (
              ""
            )}
          </Card>
        </CardContent>
        <CardActions className={"float-end"}>
          <Button
            style={{ color: mainBackground }}
            onClick={() => history.goBack()}>Go Back</Button>
          {meeting.status !== "completed" && canAccess && (
            <Button
              color="success"
              onClick={() => {
                history.push(`/admin/edit/meeting/${meeting?.id}`);
              }}
            >
              {meeting.status === "canceled" ? "ReSchedule" : "Edit"}
            </Button>
          )}
          {meeting?.status !== "completed" &&
            canAccess &&
            meeting?.status !== "canceled" ? (
            <>
              <Button
                color={"secondary"}
                onClick={() => {
                  setStatus("canceled");
                  setSelect2(true);
                  setMessage("Are you sure you want to Cancel the Meeting");
                }}>
                Cancel Meeting
              </Button>

              {owners.length ||
                selectedUsers.length ||
                selectedEmployees?.length ? (
                <Button
                  color={"success"}
                  onClick={() => {
                    setStatus(null);
                    setApply(true);
                    setMessage("Are you sure you want to save the changes");
                  }}>
                  Apply change
                </Button>
              ) : (
                ""
              )}
            </>
          ) : !meeting.hasMinutes &&
            canAccess &&
            meeting?.status !== "canceled" ? (
            <Button
              color={"secondary"}
              onClick={() => {
                history.push("/admin/create-minutes", {
                  selected: meeting?.id,
                  meeting: meeting,
                });
              }}
            >
              Write Minutes
            </Button>
          ) : meeting?.hasMinutes ? (
            <Button
              color={"success"}
              onClick={() => {
                history.push(`/admin/minutes/details/${minutes?.id}`,
                  {
                    meeting: meeting,
                  });
              }}
            >
              View Minutes
            </Button>
          ) : (
            ""
          )}
        </CardActions>
      </Card>
      <Modal
        setSelect={setViewComment}
        select={viewComment}
        title={part[0]?.status ? "Comment" : "Confirm Availability"}
      >
        {comment ? (
          <div className="p-3">{comment}</div>
        ) : (
          <form
            onSubmit={(e) => {
              confirmAvailability(e);
            }}
          >
            <div className="mb-3">
              <label className="col-form-label fw-bold text-capitalize">
                Status
                <span className="text-danger fs-6">*</span>
              </label>
              <select
                value={commentStatus}
                className="form-select text-capitalize px-3 py-3 border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                required={true}
                onChange={(e) => setCommentStatus(e.target.value)}
              >
                <option selected value="">
                  {"Select..."}
                </option>

                {["confirmed", "denied"].map((item, index) => (
                  <option key={index} value={item}>{item}</option>
                ))}
              </select>
            </div>
            <div>
              <textarea
                className="form-control px-3 py-3 border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                rows={6}
                cols={4}
                placeholder={"Type here... "}
                value={addComment}
                required={true}
                onChange={(e) => setAddComment(e.target.value)}
              />
              <CardActions className={"float-end"}>
                <Button color={"error"} onClick={() => history.goBack()}>
                  Cancel
                </Button>
                {loading ? (
                  <CircularProgress />
                ) : (
                  <SubmitButton name={"Submit"} />
                )}
              </CardActions>
            </div>
          </form>
        )}
      </Modal>

      {selectEmployee && (
        <SelectEmployee
          selectedEmployees={selectedEmployees}
          confirm={(data) => setSelectedEmployees(data)}
          getEmployees={GetEmployees}
          settings={settings}
          open={selectEmployee}
          onClose={() => setSelectEmployee(false)}
          resources={resources}
        />
      )}
      <FullScreenModal
        setSelect={setViewParticipants}
        select={viewParticipants}
      >
        <ViewParticipants
          participants={participants}
          setComment={setComment}
          setViewComment={setViewComment}
          systemSettings={systemSettings}
        />
      </FullScreenModal>
      <Snackbar
        open={snack}
        onClose={() => setSnack(false)}
        autoHideDuration={6000}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={() => setSnack(false)}
          severity="error"
          sx={{ width: "100%" }}
        >
          {errorMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default MeetingDetails;
